import {Pinia} from 'pinia'
import {useVerificationApiStore} from '@toolify/client/src/stores/api/VerificationApiStore/useVerificationApiStore'
import {
  IUpdatePasswordVerificationStrategyInterfaces,
} from '@toolify/server/src/services/VerificationService/strategies/verificationTypeStrategies/UpdatePasswordVerificationStrategy/types/IUpdatePasswordVerificationStrategyInterfaces'

export function beforeVerifyPasswordChangeRouterHookFactory(pinia: Pinia) {
  return async function beforeVerifyPasswordChangeRouterHook(to) {
    const verificationApiStore = useVerificationApiStore(pinia)
    const token = to.params.verificationId as string
    const separatorIndex = token.indexOf('-')
    const verificationId = separatorIndex === -1 ? '' : token.slice(0, separatorIndex)
    const secret = separatorIndex === -1 ? '' : token.slice(separatorIndex + 1)
    if(!verificationId || !secret) {
      to.meta.isVerificationSuccessful = false
      return
    }
    try {
      await verificationApiStore.fulfillVerification<IUpdatePasswordVerificationStrategyInterfaces>(verificationId, secret)
      to.meta.isVerificationSuccessful = true
    } catch {
      to.meta.isVerificationSuccessful = false
    }
  }
}
